import { useMutation } from '@apollo/client';
import { updateWishList } from '../../graphql/mutations/wishlistMutations';

export const useUpdateWishlist = () => {
  const [updateWishlistMutation, { loading, error }] = useMutation(updateWishList, {
    refetchQueries: ['WishListsByUserID'],
    awaitRefetchQueries: true
  });

  const sanitizeInput = (input = {}) => {
    const cleaned = { ...input };
    Object.keys(cleaned).forEach((key) => {
      if (cleaned[key] === undefined) {
        delete cleaned[key];
      }
    });
    return cleaned;
  };

  const handleWishlistUpdate = async (wishlistData) => {
    try {
      if (!wishlistData?.id) {
        throw new Error('Wishlist ID is required');
      }

      const input = sanitizeInput({
        id: wishlistData.id,
        name: wishlistData?.name
      });

      const variables = sanitizeInput({
        input,
        condition: wishlistData?.condition
      });

      const { data: wishlistResponse } = await updateWishlistMutation({
        variables
      });

      return wishlistResponse?.updateWishList;
    } catch (error) {
      console.error('Error updating wishlist:', error);
      throw error;
    }
  };

  return {
    handleWishlistUpdate,
    loading,
    error
  };
};